import React, { useEffect, useReducer, useState } from 'react';

//components
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ToolTipWrapper from  '@/components/elements/Tooltip/ToolTipWrapper';
import Overview from '../elements/insights/Overview';
import Content from  '@/components/elements/insights/Content';
import Users from  '@/components/elements/insights/Users';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import Reports from  '@/components/elements/insights/Reports';
import { container, TYPES } from "@/inversifyconfig/container.config";

//context
import { InsightsContext, IInsightsContext } from '@/context/InsightsContext'
import reducer from '../../reducers/insights';

//helpers
import { BuildPath } from  '@/helpers/Paths';
import {tooltipData} from '../../data/insights';

//interfaces
import { IHttpRequest } from  '@/interfaces/IHttp';
import { FilterPage, IReport } from  '@/interfaces/insightsp2';


import  '@/css/insights.scss';
import  '@/css/tabs.scss';

const Insights = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const [reports, setReports] = useState<IReport[]>([]);
    const [filterPage, setFilterPage] = useState<FilterPage>(null);
    const [loadMin, setLoadMin] = useState<number>(0);
    const [state, dispatch] = useReducer(reducer, {count: 0});

    const contextValues:IInsightsContext = {
        loading,
        setLoading,
        filterPage,
        setFilterPage,
        loadTracker: {
            setLoadMin,
            dispatch
        }
    }

    // Track actual loading of grid via html rendered - uselayouteffect
    useEffect(() => {

        if ((state.count && loadMin) && (state.count >= loadMin)){       
            if (loading){
                setLoading(false);
            }        
        }

    }, [state, loadMin]);

    useEffect( () => {
        // Does user have access to reports?
        container.get<IHttpRequest>(TYPES.IHttpRequest).get(`insightsreports/list`).then((x) => {
         
            if (Array.isArray(x.data)){
               setReports(x.data) 
            }  
            
        }).catch((e) => {
            console.error(`No access to reports:`, e)
        })
    }, []);
    
    return (
        <InsightsContext.Provider value={contextValues}>
            <div className="insights-container">
                <h1>Insights</h1>

                <ToolTipWrapper id="insights-top-tooltip" className="insights-top-tooltip" >                     
                    <ReactTooltip place="top" className='thrive-tooltip' delayHide={1000}  id="insights-top-tooltip" >
                        <span>{tooltipData.insightsOverall}</span>
                    </ReactTooltip>
                </ToolTipWrapper>

                <Tabs className="gen-tabs insights-tabs" defaultIndex={0}>
                    <TabList>
                        <Tab>Overview</Tab>
                        <Tab>Content</Tab>
                        <Tab>Users</Tab>
                        {reports.length > 0 && <Tab>Reports</Tab>}
                    </TabList>

                    <TabPanel className="overview">
                        <Overview />
                    </TabPanel>

                    <TabPanel>
                        <Content />
                    </TabPanel>

                    <TabPanel>
                        <Users />
                    </TabPanel>
                    
                    {reports.length > 0 && 
                        <TabPanel>
                            <Reports list={reports} />
                        </TabPanel>
                    }
                </Tabs>

                <ModalWrapper isOpen={loading} onRequestClose={() => setLoading(false)} className="loading">
                    Hang tight! We’re fetching your insights…
                    <img className="spinner" src={`${BuildPath()}/images/spinner.gif`} alt="loading..." />
                </ModalWrapper>
    
            </div>

        </InsightsContext.Provider>
    );
};

export default Insights;